module.exports = __webpack_public_path__ + "static/furniture-top-brands-section-debe1083e574e938ec2128db12a94552.png";